import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const debtApi = {
  findAll: (params: { page: number; limit: number; search?: string; customerId?: number }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/debt",
      params,
    }),

  // dueDate: sửa hạn thu; collected + collectedDate: xác nhận đã thu
  update: (id: number, data: { dueDate?: string; collected?: boolean; collectedDate?: string }): AxiosPromise<any> =>
    request({
      url: `/v1/admin/debt/${id}`,
      method: "patch",
      data,
    }),
};
